import { resolveAppEnvironment } from "./environment";
import { DEVNET_BROWSER_RPC_URL, STAGING_DEVNET } from "./network-settings";

declare const __SOLOMON_NETWORK__: { devnet: boolean; mint: string; rpcUrl: string } | undefined;

const buildProfile =
    typeof __SOLOMON_NETWORK__ === "undefined"
        ? { devnet: false, mint: "USDvUSpnhCr9yBgj3UyVrD239HRUv4RsHwH2FxsWuMk", rpcUrl: "" }
        : __SOLOMON_NETWORK__;

const environment = resolveAppEnvironment(typeof window === "undefined" ? "" : window.location.hostname);
// Deployed environments use code settings; local development retains env overrides.
const profile =
    environment === "Development"
        ? buildProfile
        : {
              devnet: environment === "Staging" && STAGING_DEVNET,
              mint:
                  environment === "Staging" && STAGING_DEVNET
                      ? "D95CXvsfXxkUry58jQ7mRV8GM5zLetkU28AJbSZKokba"
                      : "USDvUSpnhCr9yBgj3UyVrD239HRUv4RsHwH2FxsWuMk",
              rpcUrl: environment === "Staging" && STAGING_DEVNET ? DEVNET_BROWSER_RPC_URL : ""
          };

export const SOLOMON_DEVNET = profile.devnet;
export const USDV_MINT_ADDRESS = profile.mint;
interface NetworkConnectionResult {
    network: "devnet" | "mainnet-beta";
    rpcEndpoint: string;
}

export function networkConnection(mainnetRpcUrl: string): NetworkConnectionResult {
    return {
        network: SOLOMON_DEVNET ? ("devnet" as const) : ("mainnet-beta" as const),
        rpcEndpoint: profile.rpcUrl || (SOLOMON_DEVNET ? DEVNET_BROWSER_RPC_URL : mainnetRpcUrl)
    };
}
